import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings } from './settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {

  public settings = new Settings();

  constructor(public http: HttpClient) {}

  initApp(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get('assets/settings.json')
        .toPromise()
        .then(async (response: Settings) => {
          this.settings = response;
          resolve('');
        })
        .catch((err) => {
          resolve('');
        });
    });
  }



}
